import { Center, Flex, Heading, Text, VStack } from '@reverb-ui/react';
import {useContext, useEffect, useMemo, useState} from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { LOGIN } from 'router/routes';
import api from '../../services/api';
import { FormNewPassword } from './FormNewPassword';
import {AuthContext} from "../../contexts/auth";

const CreateNewPassword = () => {
  const methods = useForm({ mode: 'all' });
  const { handleSubmit } = methods;

  const history = useHistory();
  const { userName } = useContext(AuthContext)

  const searchParams = useMemo(() => new URLSearchParams(window.location.search), [])

  const [passwordToken, setPasswordToken] = useState('');

  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setPasswordToken(searchParams.get('key'));
  }, [searchParams]);

  const submitNewPassword = async (data: {
    password: string;
    confirmedPassword: string;
  }) => {
    try {
      const response = await api.patch('/Authentication/password/reset', {
        ...data,
        passwordToken,
      });

      if (response.status === 200) {
        setIsError(false);

        history.replace(LOGIN);
      }
    } catch (error) {
      setIsError(true);
    }
  };

  return (
    <Center
      data-testid="new-password"
      bg="white"
      flexDirection="column"
      borderRadius="2xl"
      w="full"
      padding={{ base: 0, "tablet-md": 12 }}
    >
      <VStack spacing={16}>
        <VStack alignItems="start" w="full">
          <Heading
            as="h1"
            fontFamily="manrope"
            fontSize={{ "base": "2xl", "tablet-md": "5xl" }}
            fontWeight="extrabold"
          >
            New password
          </Heading>
          <Text fontSize="md" maxWidth="sm">
            Hello, <strong>{userName || "Client"}</strong>! You're almost back in business. <br/> Please
            enter a new password.
          </Text>
        </VStack>
        <Flex
          width="full"
          sx={{
            '.formPassword': {
              width: '100%',
            },
          }}
        >
          <FormProvider {...methods}>
            <form
              onSubmit={handleSubmit(submitNewPassword)}
              className="formPassword"
            >
              <FormNewPassword />
            </form>
          </FormProvider>
        </Flex>
      </VStack>
    </Center>
  );
};

export default CreateNewPassword;
